module.exports = {"desc":"Issue Log : Created articles for react, javascript, css, html, ecommerce ----- (12 Jan, 2020)"}


//////////////////
// WEBPACK FOOTER
// ./src/components/docs/FirstPage.json
// module id = 171
// module chunks = 0